'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = coMiddleware;

var _co = require('co');

var _co2 = _interopRequireDefault(_co);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function coMiddleware(_ref) {
  var dispatch = _ref.dispatch;
  var getState = _ref.getState;

  return function (next) {
    return function (action) {
      return typeof action === 'function' ? (0, _co2.default)(action, dispatch, getState) : next(action);
    };
  };
} /*!
   * index.js
   * Created by Kilian Ciuffolo on Dec 23, 2015
   * (c) 2015 Kilian Ciuffolo
   */


//////////////////
// WEBPACK FOOTER
// ./~/redux-co/lib/index.js
// module id = ./node_modules/redux-co/lib/index.js
// module chunks = 0